import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const VerticalDotsIcon = ({size, color, onClick, cy}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.MEDIUM:
				return '16';
			case SIZE.STANDARD:
				return '22';
			default:
				return '10';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.MEDIUM:
				return '16';
			case SIZE.STANDARD:
				return '22';
			default:
				return '10';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)} data-cy={cy}>
			<svg x="0px" y="0px" width={getWidth(size)} height={getHeight(size)} viewBox="0 0 24 24">
				<g id="Frame_-_24px">
					<rect y="0.001" fill="none" width="24" height="24" />
				</g>
				<g id="Filled_Icons">
					<g>
						<circle fill={color} cx="12" cy="5.002" r="2" />
						<circle fill={color} cx="12" cy="12.002" r="2" />
						<circle fill={color} cx="12" cy="19.001" r="2" />
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

VerticalDotsIcon.SIZE = SIZE;
VerticalDotsIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	cy: PropTypes.string,
};

export const StyledSpan = Styled.span`
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-items: center;
	cursor: pointer;
`;
